module.exports = __webpack_public_path__ + "media/noresponse.wav";